import { ElectricBolt } from '@mui/icons-material'
import { Appliance, ApplianceConfigSolar } from './Appliance'
import { EnergyData } from '../../types/charts'
import { SolarPortControl } from '../ports/SolarPortControl'
import { PortType } from '../../types/ports'
import { ProductionStatWidget } from '../widgets/ProductionStatWidget'
import { getWidget } from '../widgets'
import { PowerGraphWidget } from '../widgets/PowerGraph'

/**
 * A solar panel.
 */
export class SolarAppliance extends Appliance<{ energy: EnergyData[] }, ApplianceConfigSolar> {

  get Icon() {
    return ElectricBolt
  }

  get height() {
    return 3
  }

  solarControl(): SolarPortControl {
    return this.findOneControl('SOLAR') as SolarPortControl
  }

  getDefaultPortType(): PortType {
    return 'SOLAR'
  }

  getDefaultWidgets(): [ProductionStatWidget, PowerGraphWidget] {
    return [
      getWidget({
        name: '',
        type: 'PRODUCTION_STAT',
        appliances: [this],
        config: {}
      }, this.control, this.app) as ProductionStatWidget,
      getWidget({
        name: '',
        type: 'POWER_GRAPH',
        appliances: [this],
        config: {}
      }, this.control, this.app) as PowerGraphWidget,
    ]
  }
}
